<template>
  <div class="page">
    <div id="page-header" class="page-header">
      <h2 class="page-header__title">受講コース一覧</h2>
    </div>
    <div id="page-content" class="page-content">
      <article>
        <section v-for="cr in courses" :key="cr.id" class="page-content__course-radio-wrapper">
          <label class="big-radio"
            ><input
              type="radio"
              name="course-radio"
              :value="cr.id"
              v-model="selectedCourse.id"
              @change="validate"
              class="big-radio--input"
            /><span class="big-radio--dummy-input"></span
            ><span class="big-radio--label-text">{{ cr.name }}</span></label
          >
        </section>
        <section class="page-content__course-description-wrapper">
          <h4 class="page-content__course-description-title">※エントリーレベルのCカードとは</h4>
          <div class="page-content__course-description-body">
            エントリーレベルのＣカードは、Ｃカードが発行された時点において、以下の範囲内で安全にダイビングをするために必要な知識とスキルを修得した証となります。<br />
            注）エントリーレベルとは、プロの監督無しで、バディとダイビングができる最初のレベルです。
            <ul>
              <li>コース受講時に経験した海況より良好なコンディションでのダイビング</li>
              <li>コース受講時に経験した最大深度の範囲でのダイビング</li>
              <li>減圧停止を必要としないダイビング</li>
              <li>コースに於いて扱い方を修得した器材を使用したダイビング</li>
              <li>潜水計画を立て、計画に従ったダイビング</li>
              <li>バディシステムに則ったダイビング</li>
            </ul>
            <a href="https://c-card.org/archives/174" target="_blank"
              >https://c-card.org/archives/174</a
            >
          </div>
        </section>
      </article>
    </div>
    <div id="page-footer" class="page-footer">
      <div class="page-footer__next-button-wrapper">
        <div class="page-footer__next-button-inner">
          <router-link to="/terms" custom v-slot="{ navigate }">
            <button id="nextButton" class="btn btn-secondary rounded-pill" @click="navigate">
              前ページに戻る
            </button>
          </router-link>
        </div>
        <div class="page-footer__next-button-inner">
          <router-link v-show="isSubmit" to="/application-form" custom v-slot="{ navigate }">
            <button id="nextButton" class="btn btn-danger rounded-pill" @click="navigate">
              コース申込画面へ進む
            </button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  /**
   * 次の画面に遷移する前に実行する
   */
  beforeRouteLeave(to, from, next) {
    this.validate();
    next(this.isSubmit); // 入力値検証がNGの場合は遷移できない
  },
  computed: {
    /**
     * コース一覧を取得する
     */
    courses: function () {
      return this.$store.getters['course/courses'];
    },
    /**
     * 次の画面に遷移可能かを判定する
     */
    isSubmit: function () {
      let result = true;
      result &= this.error === null;
      if (this.error === null) this.saveDataInStore();
      return result;
    },
  },
  data() {
    return {
      error: '',
      selectedCourse: {
        rankId: null,
        name: null,
        price: null,
        priceWithTax: null,
      },
    };
  },
  methods: {
    /**
     * 入力値をストアから取得する
     */
    getDataFromStore: function () {
      this.selectedCourse = this.$store.getters['elearningApplication/course'];
    },
    /**
     * 入力値をストアに保存する
     */
    saveDataInStore: function () {
      for (let course in this.courses) {
        // console.log('course:' + JSON.stringify(this.courses[course]));
        if (this.selectedCourse.id === this.courses[course].id) {
          this.selectedCourse.rankId = this.courses[course].rank_id;
          this.selectedCourse.name = this.courses[course].name;
          this.selectedCourse.price = this.courses[course].price;
          this.selectedCourse.priceWithTax = this.courses[course].price_with_tax;
        }
      }
      this.$store.commit('elearningApplication/setCourse', this.selectedCourse);
    },
    /**
     * 入力内容を検証する
     */
    validate: function () {
      this.error = null;
      let result = true;

      if (this.selectedCourse.id === null) {
        this.error = 'コースを選択してください';
        result = false;
      }
      // 値を数値型に変換
      this.selectedCourse.rankId = isNaN(this.selectedCourse.rankId)
        ? null
        : parseInt(this.selectedCourse.rankId);
    },
  },
  mounted() {
    this.getDataFromStore();
    this.validate();
  },
};
</script>

<style lang="scss" scoped>
@import 'stylesheets/page.scss';
@import 'stylesheets/big-radio.scss';

.page-content__course-radio-wrapper {
  padding: 0 0 1rem 0;
}

.page-content__course-description-wrapper {
  padding: 1rem 0 0 0;
}

.page-content__course-description-title {
  font-size: 1rem;
  font-weight: bold;
}

.page-content__course-description-body {
  padding: 0.5rem 0.5rem 0.5rem 0.5rem;
  font-size: 0.9rem;
}
</style>
